import axios from 'axios';

const getDefaultFaturamento = () => axios.get('/comprador/default/faturamento');
const getDefaultEntrega = () => axios.get('/comprador/default/entrega');
const getComprador = () => axios.get('/comprador');
const getCompradorById = id => axios.get(`/comprador/${id}`);
const getCompradorPage = params => axios.get('/comprador/page', { params });

const getUsuarios = params => axios.get('/comprador/user', { params });

const updateFilialFaturamento = empresa => axios.put(`/comprador/${empresa.id}/faturamento-padrao`, empresa);
const updateFilialEntrega = empresa => axios.put(`/comprador/${empresa.id}/entrega-padrao`, empresa);
const updateLogoFilial = empresa => axios.put(`/comprador/${empresa.id}/logo`, empresa);

export default {
  getDefaultFaturamento,
  getDefaultEntrega,
  getComprador,
  getCompradorById,
  getCompradorPage,
  getUsuarios,
  updateFilialFaturamento,
  updateFilialEntrega,
  updateLogoFilial,
};
